import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=0340c0a6&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=0340c0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports